import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2801aa77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checking-mic" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_3 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timer = _resolveComponent("Timer")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: ".call" }, [
      _hoisted_2
    ])),
    (_ctx.timerState !== _ctx.CallState.DISCONNECTED)
      ? (_openBlock(), _createBlock(_component_Timer, {
          key: 0,
          callState: _ctx.timerState
        }, null, 8, ["callState"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.message), 1),
    _createVNode(_component_Button, {
      class: "close",
      mode: "secondary",
      width: "fit-content",
      onClick: _ctx.stopChecking
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.btnName), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}